export default __webpack_public_path__ + "static/media/white.8a800c0e.svg";